import styled from 'styled-components';
import { Form as FormComponent } from '@unform/web';

import { colors } from '../../../../styles/tokens';
import { InputCheckboxBox } from '../../../../components/InputCheckboxBox';

export const Form = styled(FormComponent)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ContainerCheckboxBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;

  label {
    font-size: 13px;
    line-height: 1.5;
    color: ${colors.onSurfaceVariant};

    a {
      color: ${colors.primary};
    }
  }
`;

export const Checkbox = styled(InputCheckboxBox)`
  margin-top: 2px;
`;
